export default {"src":"/_next/static/media/eggplant.daea6a8f.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};